import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Tabs,
  Tab,
  Switch,
} from "@mui/material";
import axios from "axios";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import { Button, Menu, MenuItem } from "@mui/material";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import HeaderName from "../HeaderName";
import SideBar from "../SideBar";
import { API_URL } from "../../../api/api";

function CommissionList() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [doctorLists, setDoctorLists] = useState([]);
  const [doctorID, setDoctorID] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [commissions, setCommissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filterDoctor, setFilterDoctor] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [selectedCommissions, setSelectedCommissions] = useState([]);
  const [totalSelectedAmount, setTotalSelectedAmount] = useState(0);
  const [collectDate, setCollectDate] = useState("");
  const [remark, setRemark] = useState("");
  const [tabValue, setTabValue] = useState("doctor");
  const [therapistLists, setTherapistLists] = useState([]);
  const [statusTab, setStatusTab] = useState("unpaid");
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusModalDate, setStatusModalDate] = useState("");
  const [statusModalRowId, setStatusModalRowId] = useState(null);
  const [pendingCount, setPendingCount] = useState();
  const [isAppointmentDate, setIsAppointmentDate] = useState(true);

  const handleOpenDialog = () => setOpenDialog(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setShowDate(false);
  };

  const _export = React.useRef(null);

  const excelExport = async () => {
    try {
      const allCommissions = await getAllCommissionsForExport();
      
      const allExportData = allCommissions.map((row, index) => ({
        no: index + 1,
        voucherCode: row?.relatedTreatmentVoucher?.code || "N/A",
        patientName: row?.relatedTreatmentVoucher?.relatedPatient?.name || "N/A",
        doctorName:
          tabValue === "doctor"
            ? row?.relatedDoctor?.name
            : row?.relatedTherapist?.name || "N/A",
        voucherDate: row?.relatedTreatmentVoucher?.createdAt
          ? new Date(row.relatedTreatmentVoucher.createdAt).toLocaleDateString()
          : "N/A",
        treatmentName: row?.treatmentBreakdown[0]?.treatmentId?.name,
        treatmentCount: row?.treatmentBreakdown?.length || 0,
        percent: row?.percent ? `${row.percent}%` : "0%",
        commissionAmount: row?.commissionAmount || 0,
        appointmentAmount: row?.appointmentAmount || 0,
        appointmentStatus: row?.relatedAppointment?.usageStatus || "N/A",
        status: row?.status || "Unpaid",
        createdAt: row?.createdAt
          ? new Date(row.createdAt).toLocaleDateString()
          : "N/A",
      }));

      if (_export.current !== null) {
        _export.current.save(allExportData);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Failed to export data. Please try again.");
    }
  };

  const exportData = commissions.map((row, index) => ({
    no: index + 1,
    voucherCode: row?.relatedTreatmentVoucher?.code || "N/A",
    patientName: row?.relatedTreatmentVoucher?.relatedPatient?.name || "N/A",
    doctorName:
      tabValue === "doctor"
        ? row?.relatedDoctor?.name
        : row?.relatedTherapist?.name || "N/A",
    voucherDate: row?.relatedTreatmentVoucher?.createdAt
      ? new Date(row.relatedTreatmentVoucher.createdAt).toLocaleDateString()
      : "N/A",
    treatmentName: row?.treatmentBreakdown[0]?.treatmentId?.name,
    treatmentCount: row?.treatmentBreakdown?.length || 0,
    percent: row?.percent ? `${row.percent}%` : "0%",
    commissionAmount: row?.commissionAmount || 0,
    appointmentAmount: row?.appointmentAmount || 0,
    appointmentStatus: row?.relatedAppointment?.usageStatus || "N/A",
    status: row?.status || "Unpaid",
    createdAt: row?.createdAt
      ? new Date(row.createdAt).toLocaleDateString()
      : "N/A",
  }));

  useEffect(() => {
    const getLists = async () => {
      const doctorRes = await api.get("doctors");
      const therapistRes = await api.get("therapists");

      setDoctorLists(doctorRes.data.data);
      setTherapistLists(therapistRes.data.data);
    };

    getLists();
  }, []);

  const toISODate = (date, isEnd = false) => {
    if (!date) return "";

    const d = new Date(date);

    if (isEnd) {
      d.setHours(23, 59, 59, 999);
    } else {
      d.setHours(0, 0, 0, 0);
    }

    return d.toISOString();
  };

  const [usageStatusTab, setUsageStatusTab] = useState("finished");

  const usageStatusMap = {
    pending: "Pending",
    inProgress: "In Progress",
    finished: "Finished",
    due: "Due",
  };

  const getCommission = async () => {
    let query = `commissions?page=${page + 1}&limit=${rowsPerPage}`;

    if (filterDoctor) {
      query += `&${
        tabValue === "doctor" ? "relatedDoctor" : "relatedTherapist"
      }=${filterDoctor}`;
    }

    if (filterStartDate) {
      query += `&startDate=${toISODate(filterStartDate)}`;
    }

    if (filterEndDate) {
      query += `&endDate=${toISODate(filterEndDate, true)}`;
    }

    query += `&commissionFor=${tabValue === "doctor" ? "Doctor" : "Therapist"}`;

    const usageStatusValue = usageStatusMap[usageStatusTab];

    if (usageStatusValue) {
      query += `&usageStatus=${encodeURIComponent(usageStatusValue)}`;
    }

    let statusValue = "";
    if (statusTab === "unpaid") statusValue = "Unpaid";
    else if (statusTab === "pending") statusValue = "Pending";
    else if (statusTab === "paid") statusValue = "Paid";

    if (statusValue) {
      query += `&status=${statusValue}`;
    }

    query += `&isAppointmentDate=${isAppointmentDate}`;

    const res = await api.get(query);

    setCommissions(res.data.data);
    setTotalCount(res.data._metadata.total);
  };

  const getAllCommissionsForExport = async () => {
    let query = `commissions`;

    if (filterDoctor) {
      query += `&${
        tabValue === "doctor" ? "relatedDoctor" : "relatedTherapist"
      }=${filterDoctor}`;
    }

    if (filterStartDate) {
      query += `&startDate=${toISODate(filterStartDate)}`;
    }

    if (filterEndDate) {
      query += `&endDate=${toISODate(filterEndDate, true)}`;
    }

    query += `?commissionFor=${tabValue === "doctor" ? "Doctor" : "Therapist"}`;

    const usageStatusValue = usageStatusMap[usageStatusTab];

    if (usageStatusValue) {
      query += `&usageStatus=${encodeURIComponent(usageStatusValue)}`;
    }

    let statusValue = "";
    if (statusTab === "unpaid") statusValue = "Unpaid";
    else if (statusTab === "pending") statusValue = "Pending";
    else if (statusTab === "paid") statusValue = "Paid";

    if (statusValue) {
      query += `&status=${statusValue}`;
    }

    query += `&isAppointmentDate=${isAppointmentDate}`;

    const res = await api.get(query);
    return res.data.data;
  };

  const getPendingCount = async () => {
    let query = `commissions?page=1&limit=1`;

    query += `&commissionFor=${tabValue === "doctor" ? "Doctor" : "Therapist"}`;
    query += `&status=Pending`;

    const res = await api.get(query);
    setPendingCount(res.data._metadata.total);
  };

  useEffect(() => {
    getPendingCount();
  }, [tabValue]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const handleMenuClick = (event, rowId, status) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);

    if (status === "Paid") {
      setStatusModalRowId(rowId);
      setStatusModalOpen(true);
    } else if (status === "Unpaid") {
      handleStatusChange("Unpaid", rowId);
    }
  };

  const handleStatusModalClose = () => {
    setStatusModalOpen(false);
    setStatusModalDate("");
    setStatusModalRowId(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  const handleStatusChange = async (
    status,
    rowId = selectedRowId,
    date = null,
  ) => {
    try {
      const payload = { status };
      if (status === "Paid") {
        payload.collectDate = date;
      }

      await api.put(`/commissions-statusChange/${rowId}`, payload);

      handleStatusModalClose();
      handleMenuClose();

      getCommission();
    } catch (err) {
      console.error(err);
      alert("Failed to update status!");
    }
  };

  useEffect(() => {
    getCommission();
  }, [
    page,
    rowsPerPage,
    filterDoctor,
    filterStartDate,
    filterEndDate,
    tabValue,
    statusTab,

    usageStatusTab,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const navigate = useNavigate();

  const handleCollect = async () => {
    if (selectedCommissions.length === 0) {
      alert("Please select at least one commission.");
      return;
    }

    const payload = {
      commissionIds: selectedCommissions,
      previousCommissionAmount: totalSelectedAmount,
      collectDate,
      remark,
    };

    try {
      const res = await api.post("commissions-pay", payload);
      navigate("/paid-commission");

      setSelectedCommissions([]);
      setTotalSelectedAmount(0);
      setCollectDate("");
      setRemark("");
      handleCloseDialog();
      getCommission();
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };
  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <Box p={2}>
            <h4 className="fs-5 py-3">Commission List</h4>
            <Box
              px={2}
              pb={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Tabs
                value={tabValue}
                onChange={(e, newValue) => {
                  setTabValue(newValue);
                  setPage(0);

                  setDoctorID("");
                  setFilterDoctor("");

                  setSelectedCommissions([]);
                  setTotalSelectedAmount(0);
                }}
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab label="Doctor" value="doctor" />
                <Tab label="Therapist" value="therapist" />
              </Tabs>

              <Tabs
                value={statusTab}
                onChange={(e, newValue) => {
                  setStatusTab(newValue);
                  setPage(0);
                }}
                textColor="primary"
                indicatorColor="primary"
              >
                {pendingCount > 0 && <Tab label="Pending" value="pending" />}
                <Tab label="Paid" value="paid" />
                <Tab label="Unpaid" value="unpaid" />
              </Tabs>
            </Box>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3} display="flex" alignItems="center">
                <FormControlLabel
                  label="Appointment Date"
                  labelPlacement="start"
                  control={
                    <Switch
                      checked={isAppointmentDate}
                      onChange={(e) => setIsAppointmentDate(e.target.checked)}
                      color="primary"
                    />
                  }
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    mb: 0.5,
                    color: "gray",
                  }}
                >
                  Start Date
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  value={startDate}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    mb: 0.5,
                    color: "gray",
                  }}
                >
                  End Date
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  value={endDate}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={5} textAlign="right">
                <Button
                  variant="contained"
                  sx={{ mr: 1, backgroundColor: "#1565C0" }}
                  onClick={() => {
                    setDoctorID("");
                    setStartDate("");
                    setEndDate("");

                    setFilterDoctor("");
                    setFilterStartDate("");
                    setFilterEndDate("");

                    setPage(0);
                  }}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 1, backgroundColor: "#1565C0" }}
                  onClick={() => {
                    setFilterDoctor(doctorID);
                    setFilterStartDate(startDate);
                    setFilterEndDate(endDate);
                    setPage(0);
                  }}
                >
                  Filter
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 1, backgroundColor: "#1565C0" }}
                  onClick={excelExport}
                >
                  Export
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#34A853" }}
                  onClick={handleOpenDialog}
                >
                  Paid
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              pt={3}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={12} md={3}>
                <Typography sx={{ fontSize: "0.75rem", fontWeight: 600 }}>
                  {tabValue === "doctor" ? "Doctor Name" : "Therapist Name"}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  select
                  value={doctorID}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setDoctorID(selected);
                    setFilterDoctor(selected);
                    setPage(0);
                  }}
                >
                  <MenuItem value="">
                    {tabValue === "doctor" ? "All Doctors" : "All Therapists"}
                  </MenuItem>

                  {(tabValue === "doctor" ? doctorLists : therapistLists)?.map(
                    (option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.name}
                      </MenuItem>
                    ),
                  )}
                </TextField>
              </Grid>
              <Box
                px={2}
                pt={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Tabs
                  value={usageStatusTab}
                  onChange={(e, newValue) => {
                    setUsageStatusTab(newValue);
                    setPage(0);
                  }}
                >
                  <Tab label="Pending" value="pending" />
                  <Tab label="In Progress" value="inProgress" />
                  <Tab label="Finished" value="finished" />
                  <Tab label="Due" value="due" />
                </Tabs>
              </Box>
            </Grid>
            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{doctorID ? "Doctor's Commissions" : "Commissions"}</span>

                <Link to="/paid-commission" className="btn btn-sm btn-success">
                  Paid Commission
                </Link>
              </DialogTitle>

              <DialogContent dividers>
                <div className="row">
                  <div className="col-6">
                    <h5 className="fs-5">
                      {doctorID ? doctorID + "'s Commissions" : ""}
                    </h5>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label>Previous Collect Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={totalSelectedAmount}
                      readOnly
                    />
                  </div>

                  <div className="col-4">
                    <label>Collect Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={collectDate}
                      onChange={(e) => setCollectDate(e.target.value)}
                    />
                  </div>

                  <div className="col-4">
                    <label>Remark</label>
                    <input
                      type="text"
                      className="form-control"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                </div>
              </DialogContent>

              <DialogActions>
                <Button onClick={handleCloseDialog} color="error">
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleCollect}
                >
                  Collect
                </Button>
              </DialogActions>
            </Dialog>
            <ExcelExport data={exportData} ref={_export}>
              <ExcelExportColumn field="no" title="#" width={50} />
              <ExcelExportColumn field="voucherCode" title="Voucher Code" />
              <ExcelExportColumn field="patientName" title="Patient Name" />
              <ExcelExportColumn field="doctorName" title="Doctor Name" />
              <ExcelExportColumn field="voucherDate" title="Voucher Date" />
              <ExcelExportColumn field="treatmentName" title="Treatment Name" />
              <ExcelExportColumn
                field="treatmentCount"
                title="Treatment Count"
              />
              <ExcelExportColumn field="percent" title="Percent (%)" />
              <ExcelExportColumn
                field="commissionAmount"
                title="Commission Amount"
              />
              <ExcelExportColumn
                field="appointmentAmount"
                title="Appointment Amount"
              />
              <ExcelExportColumn
                field="appointmentStatus"
                title="Appointment Status"
              />
              <ExcelExportColumn field="status" title="Status" />
              <ExcelExportColumn field="createdAt" title="Created At" />
            </ExcelExport>
          </Box>

          {/* <!-- Main content --> */}
          <Paper sx={{ p: 2, mt: 2, borderRadius: 2 }}>
            <div className="row">
              <div class="col-md-12 card px-3 py-3">
                <div class="table-responsive text-black" id="slimtest2">
                  <>
                    <TableContainer
                      component={Paper}
                      sx={{ maxWidth: "100%", overflowX: "auto" }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            {statusTab === "unpaid" && (
                              <TableCell
                                sx={{
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              ></TableCell>
                            )}
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              #
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Voucher Code
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Patient Name
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Doctor Name
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Voucher Date
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Treatment Name
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Treatment Count
                            </TableCell>

                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Percent (%)
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Commission Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Appointment Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Appointment Status
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Status
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Created At
                            </TableCell>
                            {statusTab === "pending" && (
                              <TableCell
                                sx={{
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Action
                              </TableCell>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {commissions.map((row, index) => (
                            <TableRow key={row._id}>
                              {statusTab === "unpaid" && (
                                <TableCell padding="checkbox">
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      size="small"
                                      checked={selectedCommissions.includes(
                                        row._id,
                                      )}
                                      onChange={(e) => {
                                        let updatedSelection = [];
                                        if (e.target.checked) {
                                          updatedSelection = [
                                            ...selectedCommissions,
                                            row._id,
                                          ];
                                        } else {
                                          updatedSelection =
                                            selectedCommissions.filter(
                                              (id) => id !== row._id,
                                            );
                                        }
                                        setSelectedCommissions(
                                          updatedSelection,
                                        );

                                        const total = commissions
                                          .filter((c) =>
                                            updatedSelection.includes(c._id),
                                          )
                                          .reduce(
                                            (sum, c) =>
                                              sum + (c.commissionAmount || 0),
                                            0,
                                          );
                                        setTotalSelectedAmount(total);
                                      }}
                                    />
                                  </TableCell>
                                </TableCell>
                              )}
                              <TableCell>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell>
                                {row?.relatedTreatmentVoucher?.code || "N/A"}
                              </TableCell>
                              <TableCell>
                                {row?.relatedTreatmentVoucher?.relatedPatient
                                  ?.name || "N/A"}
                              </TableCell>
                              <TableCell>
                                {tabValue === "doctor"
                                  ? row?.relatedDoctor?.name || "N/A"
                                  : row?.relatedTherapist?.name || "N/A"}
                              </TableCell>
                              <TableCell>
                                {row?.relatedTreatmentVoucher?.createdAt
                                  ? new Date(
                                      row.relatedTreatmentVoucher.createdAt,
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                {row?.treatmentBreakdown[0]?.treatmentId
                                  ?.name || "N/A"}
                              </TableCell>
                              <TableCell>
                                {row?.treatmentBreakdown?.length || 0}
                              </TableCell>
                              <TableCell>
                                {row?.percent + "%" || "N/A"}
                              </TableCell>
                              <TableCell>
                                {row?.commissionAmount?.toLocaleString() || "0"}
                              </TableCell>
                              <TableCell>
                                {row?.appointmentAmount?.toLocaleString() ||
                                  "0"}
                              </TableCell>

                              <TableCell>
                                {row?.relatedAppointment?.usageStatus ? (
                                  <Chip
                                    label={row.relatedAppointment.usageStatus}
                                    color={
                                      row.relatedAppointment.usageStatus ===
                                      "Pending"
                                        ? "warning"
                                        : row.relatedAppointment.usageStatus ===
                                            "In Progress"
                                          ? "info"
                                          : row.relatedAppointment
                                                .usageStatus === "Finished"
                                            ? "success"
                                            : row.relatedAppointment
                                                  .usageStatus === "Due"
                                              ? "error"
                                              : "default"
                                    }
                                    variant="outlined"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                ) : (
                                  "N/A"
                                )}
                              </TableCell>
                              <TableCell>
                                {row?.status ? (
                                  <Chip
                                    label={row.status}
                                    color={
                                      row.status.toLowerCase() === "unpaid"
                                        ? "error"
                                        : row.status.toLowerCase() === "pending"
                                          ? "warning"
                                          : row.status.toLowerCase() === "paid"
                                            ? "success"
                                            : "default"
                                    }
                                    variant="outlined"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                ) : (
                                  <Chip
                                    label="Unpaid"
                                    color="error"
                                    variant="outlined"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                {row?.createdAt
                                  ? new Date(row.createdAt).toLocaleDateString()
                                  : "N/A"}
                              </TableCell>
                              {statusTab === "pending" && (
                                <TableCell>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={(e) =>
                                      handleMenuClick(e, row._id, "Paid")
                                    }
                                    sx={{ mr: 1 }}
                                  >
                                    Paid
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={(e) =>
                                      handleMenuClick(e, row._id, "Unpaid")
                                    }
                                  >
                                    Unpaid
                                  </Button>
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Dialog
                      open={statusModalOpen}
                      onClose={handleStatusModalClose}
                      maxWidth="sm" // or "md" for larger
                      fullWidth
                      PaperProps={{
                        sx: {
                          borderRadius: 3,
                          p: 3,
                          backgroundColor: "#f9f9f9",
                        },
                      }}
                    >
                      <DialogTitle
                        sx={{
                          fontWeight: "bold",
                          fontSize: "1.25rem",
                          color: "#1565C0",
                          textAlign: "center",
                          mb: 1,
                        }}
                      >
                        Confirm Payment
                      </DialogTitle>

                      <DialogContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Typography sx={{ fontSize: "0.95rem" }}>
                          Please select the collection date before marking as
                          Paid.
                        </Typography>

                        <TextField
                          type="date"
                          value={statusModalDate}
                          onChange={(e) => setStatusModalDate(e.target.value)}
                          fullWidth
                          sx={{
                            mt: 1,
                            "& .MuiInputBase-root": {
                              backgroundColor: "white",
                              borderRadius: 1,
                            },
                          }}
                        />
                      </DialogContent>

                      <DialogActions
                        sx={{ justifyContent: "space-between", mt: 1 }}
                      >
                        <Button
                          onClick={handleStatusModalClose}
                          color="error"
                          variant="outlined"
                          sx={{ fontWeight: 600 }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          color="success"
                          disabled={!statusModalDate}
                          onClick={() =>
                            handleStatusChange(
                              "Paid",
                              statusModalRowId,
                              statusModalDate,
                            )
                          }
                          sx={{ fontWeight: 600 }}
                        >
                          Paid
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <TablePagination
                      component="div"
                      count={totalCount}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",

                        "& .MuiTablePagination-toolbar": {
                          display: "flex",
                          alignItems: "center",
                          minHeight: "52px",
                        },

                        "& .MuiTablePagination-selectLabel": {
                          margin: 0,
                          display: "flex",
                          alignItems: "center",
                        },

                        "& .MuiTablePagination-displayedRows": {
                          margin: 0,
                          display: "flex",
                          alignItems: "center",
                        },

                        "& .MuiTablePagination-actions": {
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                    />
                  </>
                </div>
              </div>
            </div>
          </Paper>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
}

export default CommissionList;
